<script setup>
import { ref, onMounted } from 'vue'
import { RadioGroup, RadioGroupDescription, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue'
import { CheckCircleIcon } from '@heroicons/vue/20/solid'

const visibilities = [
    { id: 2, title: 'Sichtbar mit Freigabe', description: 'Teilnehmende Unternehmen müssen dir eine Anfrage senden, um dein vollständiges Profil zu sehen. Ansonsten sehen sie nur: <ul class="tw-mt-2 tw-pl-7"><li>Unkenntliches Profilbild</li><li>Vorname</li><li>Wonach du suchst</li></ul>' },
    { id: 1, title: 'Sichtbar ohne Freigabe', description: 'Teilnehmende Unternehmen können dein vollständiges Profil einsehen. Du kannst diese Einstellung jederzeit ändern.' },
]

const props = defineProps(['visibility']);
const selectedVisibility = ref(visibilities[props.visibility]);
</script>

<template>
    <div class="tw-rounded tw-border tw-p-5 tw-mb-5 tw-relative tw-group tw-bg-gray-100">

        <RadioGroup v-model="selectedVisibility">
            <h3 class="sm:tw-col-span-6">Wer kann dein Profil sehen?</h3>
            <p class="tw-mb-0">Nur teilnehmende Unternehmen können dein Profil sehen, keine Besucher der Website.
                Entscheide hier genauer, welche Unternehmen es sehen dürfen.</p>


            <div class="tw-mt-4 tw-grid tw-grid-cols-1 tw-gap-y-6 sm:tw-grid-cols-2 sm:tw-gap-x-4">
                <RadioGroupOption as="template" v-for="visibility in visibilities" :key="visibility.id"
                    :value="visibility" v-slot="{ active, checked }">
                    <div
                        :class="[active ? 'tw-border-indigo-600 tw-ring-2 tw-ring-indigo-600' : 'tw-border-gray-300', 'tw-relative tw-flex tw-cursor-pointer tw-rounded-lg tw-border tw-bg-white tw-p-4 tw-shadow-sm focus:tw-outline-none']">
                        <span class="tw-flex tw-flex-1">
                            <span class="tw-flex tw-flex-col">
                                <RadioGroupLabel as="span" class="tw-block tw-text-sm tw-font-medium tw-text-gray-900">
                                    {{
            visibility.title
        }}</RadioGroupLabel>
                                <RadioGroupDescription as="span" class="tw-mt-1 tw-text-sm tw-text-gray-500"
                                    v-html="visibility.description"></RadioGroupDescription>
                            </span>
                        </span>
                        <CheckCircleIcon :class="[!checked ? 'tw-invisible' : '', 'tw-h-5 tw-w-5 tw-text-indigo-600']"
                            aria-hidden="true" />
                        <span
                            :class="[active ? 'tw-border' : 'tw-border-2', checked ? 'tw-border-indigo-600' : 'tw-border-transparent', 'tw-pointer-events-none tw-absolute tw--inset-px tw-rounded-lg']"
                            aria-hidden="true" />
                    </div>
                </RadioGroupOption>
            </div>
        </RadioGroup>
    </div>

    <input name="visibility" class="tw-hidden" :value="selectedVisibility.id == 1 & 1">
</template>
